export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const CHARITY_NAVIGATOR_API = 'https://data.charitynavigator.org'
export const S3_BUCKET_NAME = 'hys';